import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { pageTopPadding } from '../styles/layout';

const GOLD = '#C9A84C';
const BG = '#090909';

const NotFound = () => (
  <>
    <Helmet>
      <title>Page Not Found | Digital Divot Golf</title>
      <meta name="description" content="The page you are looking for could not be found." />
    </Helmet>
    <div
      style={{
        paddingTop: pageTopPadding(false),
        backgroundColor: BG,
        color: '#F5F0E8',
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
      }}
    >
      <div>
        <h1 style={{ fontSize: '4rem', fontWeight: '800', color: GOLD, margin: '0 0 0.5rem' }}>
          404
        </h1>
        <p style={{ fontSize: '1.25rem', marginBottom: '2rem', color: '#9CA3AF' }}>
          This page doesn&apos;t exist or may have moved.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link
            to="/"
            style={{
              backgroundColor: GOLD,
              color: '#000',
              padding: '0.75rem 1.5rem',
              borderRadius: '9999px',
              textDecoration: 'none',
              fontWeight: '700',
            }}
          >
            Go Home
          </Link>
          <Link
            to="/booking"
            style={{
              border: `2px solid ${GOLD}`,
              color: GOLD,
              padding: '0.75rem 1.5rem',
              borderRadius: '9999px',
              textDecoration: 'none',
              fontWeight: '700',
            }}
          >
            Book a Simulator
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default NotFound;
